import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const PopularArticles = ({ articles }) => {
  const popularArticles = articles.slice(0, 5);

  return (
    <div className="bg-surface rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-text-primary mb-4 flex items-center">
        <Icon name="TrendingUp" size={20} className="text-accent mr-2" />
        Artículos Populares
      </h3>
      
      <div className="space-y-4">
        {popularArticles.map((article, index) => (
          <article key={article.id} className="group">
            <Link
              to={`/blog-resources/${article.id}`}
              className="flex space-x-3 hover:bg-primary/5 p-2 -m-2 rounded-lg nav-transition"
            >
              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="w-12 h-12 rounded-lg overflow-hidden">
                    <Image
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-110 nav-transition"
                    />
                  </div>
                  <div className="absolute -top-1 -left-1 w-5 h-5 bg-accent text-white rounded-full flex items-center justify-center text-xs font-bold">
                    {index + 1}
                  </div>
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-text-primary line-clamp-2 group-hover:text-primary nav-transition">
                  {article.title}
                </h4>
                <div className="flex items-center space-x-2 mt-1 text-xs text-text-secondary">
                  <div className="flex items-center space-x-1">
                    <Icon name="Calendar" size={10} />
                    <span>{new Date(article.publishDate).toLocaleDateString('es-CR')}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={10} />
                    <span>{article.readTime}</span>
                  </div>
                </div>
                
                {/* Category Badge */}
                <div className="mt-2">
                  <span className="inline-flex items-center space-x-1 bg-primary/10 text-primary px-2 py-1 rounded-md text-xs">
                    <Icon 
                      name={
                        article.category === 'maintenance' ? 'Wrench' :
                        article.category === 'chemicals' ? 'Beaker' :
                        article.category === 'equipment' ? 'Settings' :
                        article.category === 'seasonal' ? 'Calendar' : 'BookOpen'
                      } 
                      size={10} 
                    />
                    <span className="capitalize">{article.category}</span>
                  </span>
                </div>
              </div>
            </Link>
          </article>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-border">
        <Link
          to="/blog-resources"
          className="flex items-center justify-center space-x-2 text-primary font-medium hover:text-primary/80 nav-transition"
        >
          <span>Ver todos los artículos</span>
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default PopularArticles;